import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';
import { IApplicationState } from '../../store/applicationState';
import { IGroupState } from '../../store/group/groupState';
import * as genericExtensions from '../../genericExtensions'

interface INetworkChooserStateProps {
    groupData: IGroupState;
}

type NetworkChooserProps = INetworkChooserStateProps;

class NetworkChooserIndex extends React.Component<NetworkChooserProps, {}> {
    public render() {
        return <React.Fragment>
            <section className="section">
                <div className="deck">
                    <div className="w--md">
                        <article className="article article--no-initial">
                            <div className="rich-text">
                                {this.renderContent()}
                            </div>
                        </article>
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }

    private renderContent() {
        if (!this.props.groupData.groups.isLoaded || this.props.groupData.groups.isLoading) {
            return <Spinner size={SpinnerSize.Large} />;
        }

        if (this.props.groupData.groups.groups && this.props.groupData.groups.groups.allIds.length) {
            if (this.props.groupData.currentGroup) {
                const preferredGroup = genericExtensions.all(this.props.groupData.groups.groups).firstOrDefault(g => g.id === this.props.groupData.currentGroup);

                if (preferredGroup) {
                    return <Redirect to={`/Group/${preferredGroup.alias}`} />;
                }
            }

            const firstGroup = this.props.groupData.groups.groups.byId[this.props.groupData.groups.groups.allIds[0]];

            return <Redirect to={`/Group/${firstGroup.alias || firstGroup.id}`} />;
        }

        return <p>Vi kan ikke finde nogen aktive grupper, som du er medlem af. Kontakt <a href="mailto:medlem@di.dk">medlem@di.dk</a> hvis du mener det er en fejl, og skriv navnet på den gruppe du forventede at være medlem af.</p>;
    }
}

const mapStateToProps = (state: IApplicationState): INetworkChooserStateProps => ({
    groupData: state.groupData
});

const container = connect(mapStateToProps, {})(NetworkChooserIndex);

export default container;